import moment from 'moment';
import {
  FormattedApexChart,
  PerfilUsuarioAcessos,
  TotalAtendimentos,
} from '../dashboard.interfaces';

export function TotalFormat(data: TotalAtendimentos | undefined) {
  if (!data) {
    return {
      categories: { categories: [] },
      series: [],
      total: 0,
    };
  }

  const series = [
    {
      name: data.total.name,
      data: data.atendimentos.map((item) => item.total),
    },
  ];

  const categories = {
    categories: data.atendimentos.map((item) =>
      moment(item.data).format('DD MMM')
    ),
  };

  const total = data.total.data;

  return {
    series,
    categories,
    total,
  };
}

export function formattedPerfilUsuarioAcessos(
  data: PerfilUsuarioAcessos | undefined
): FormattedApexChart {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }

  const series = [
    {
      name: 'Total',
      data: data.perfis.map(
        (perfil) => perfil.pessoaFisica + perfil.pessoaJuridica
      ),
    },
    {
      name: 'Pessoa Física',
      data: data.perfis.map((perfil) => perfil.pessoaFisica),
    },
    {
      name: 'Pessoa Jurídica',
      data: data.perfis.map((perfil) => perfil.pessoaJuridica),
    },
  ];

  const categories = {
    categories: data.perfis.map((item) => moment(item.data).format('DD MMM')),
  };

  const total = data.pessoaFisica + data.pessoaJuridica;

  return {
    series,
    categories,
    total,
  };
}
